import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LayoutEdicaoService {
  public ano = new BehaviorSubject<string>('');
  public pais = new BehaviorSubject<string>('');
  public estado = new BehaviorSubject<string>('');
  public cidade = new BehaviorSubject<string>('');
  public redeSelecionada = new BehaviorSubject<string>('');
  public imagemFundo = new BehaviorSubject<string>(
    'assets/ilustrations/bridge-mountain.svg',
  );

  public tituloEdicao = new BehaviorSubject<string>('');
  public corTituloEdicao = new BehaviorSubject<string>('');
  public corBordaEdicao = new BehaviorSubject<string>('');

  setAno(ano: string) {
    this.ano.next(ano);
  }

  getAno(): Observable<string> {
    return this.ano.asObservable();
  }

  setPais(pais: string) {
    this.pais.next(pais);
  }

  getPais(): Observable<string> {
    return this.pais.asObservable();
  }

  setEstado(estado: string) {
    this.estado.next(estado);
  }

  getEstado(): Observable<string> {
    return this.estado.asObservable();
  }

  setCidade(cidade: string) {
    this.cidade.next(cidade);
  }

  getCidade(): Observable<string> {
    return this.cidade.asObservable();
  }

  setRedeSelecionada(redeSelecionada: string) {
    this.redeSelecionada.next(redeSelecionada);
  }

  getRedeSelecionada(): Observable<string> {
    return this.redeSelecionada.asObservable();
  }

  setImagemFundo(imagemFundo: string) {
    this.imagemFundo.next(imagemFundo);
  }

  getImagemFundo(): Observable<string> {
    return this.imagemFundo.asObservable();
  }

  setTituloEdicao(titulo: string) {
    this.tituloEdicao.next(titulo);
  }

  setCorTituloEdicao(cor: string) {
    this.corTituloEdicao.next(cor);
  }

  setCorBordaEdicao(cor: string) {
    this.corBordaEdicao.next(cor);
  }

  getTituloEdicao(): Observable<string> {
    return this.tituloEdicao.asObservable();
  }

  getCorTituloEdicao(): Observable<string> {
    return this.corTituloEdicao.asObservable();
  }

  getCorBordaEdicao(): Observable<string> {
    return this.corBordaEdicao.asObservable();
  }
}
